<div class="container-fluid paddEqual bgGray">
    <div class="container">
        <div class="row">
            <div class="col-md-10 offset-md-1 text-center page-404">
                <h1>404</h1>
                <h2>...Oops! Something is missing</h2>

            </div>
            <div class="col-md-10 offset-md-1 text-center">
                <a href="javascript:void(0)" routerLink="/" class="btn btn-danger">Home</a>
            </div>
        </div>
    </div>
</div>